import React from 'react';
import classes from "./OtpPage.module.css";
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SendOtpAPI, VerifyOtpAPI } from '../Api/api';
import { toast } from 'react-toastify';
import { useEffect } from 'react';
import { motion, useAnimation } from "framer-motion";
import { Canvas } from "@react-three/fiber";
import { Stars } from "@react-three/drei";
import OTPInput from 'react-otp-input';

const OtpPage = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [extRef, setExtRef] = useState(null);
    const [referenceNo, setReferenceNo] = useState(null);
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            setExtRef(location?.state?.extRef);
            setReferenceNo(location?.state?.referenceNo);
        }
        else {
            // navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            if (otp.length <= 5) {
                return;
            }
            setLoading(true);
            const response = await VerifyOtpAPI(msisdn, otp, referenceNo, extRef);
            console.log(response, 'response---');
            setLoading(false);
            navigate("/subscription-processing", {
                state: {
                    msisdn: msisdn
                }
            })
        } catch (error) {
            setLoading(false);
            console.log(error, 'error---');

            if (error?.response?.data?.status == 0) {
                toast.error("Wrong OTP");
            }
            else if (error?.response?.data?.status == 1) {
                toast.info("Subscribe Successfully");
                navigate("/low-balance");
            }
            else {
                toast.error("Something Went Wrong!");
            }
        }
    }

    const resendOtpHandler = async () => {
        try {
            setResendLoading(true);

            const response = await SendOtpAPI(msisdn);
            setTimer(120);
            setResendLoading(false);
            if (response?.data?.status == 1) {
                setResend(true);
                setOtp("");
                toast.success("OTP Resend Successfully!");
            }
            else {
                toast.error("Failed to Send OTP!");
            }
        } catch (error) {
            setResendLoading(false);
            toast.error("Something Went Wrong!");
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <section className={classes.landing}>
            <motion.div
                className={classes.container}
                initial={{
                    backgroundImage: "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                }}
                animate={{
                    backgroundImage: [
                        "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #f5b342)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #8e44ad)",
                        "radial-gradient(820% 320% at 50% 25%, #000, #602A9A)",
                    ],
                }}
                transition={{
                    duration: 6,
                    ease: "easeInOut",
                    repeat: Infinity,
                    repeatType: "mirror",
                }}
            >
                <div className={classes.stars}>
                    <Canvas>
                        <Stars
                            radius={50}
                            depth={50}
                            count={1000}
                            factor={4}
                            saturation={0}
                            fade
                            speed={2}
                        />
                    </Canvas>
                </div>
            </motion.div>
            <div className={classes.main}>
                <header className={classes.header}>
                    <nav className={classes.nav}>
                        <div className={classes.logo_container}
                        >
                            <img
                                src="./assets/images/logo-white.png"
                                alt="ai"
                                className={classes.logo}
                            />
                        </div>

                        {/* <div className={classes.nav_sub_container}>
                            <button
                                type="button"
                                className={classes.sign_in_btn}
                                onClick={() => {
                                    navigate(`/login?ext_ref=${extRef}`)
                                }}
                            >
                                Login
                            </button>
                        </div> */}
                    </nav>
                </header>
                <div className={classes.product_description_container}>
                    <div className={classes.otp_container}>
                        <div className={classes.otp_description}>
                            <h2 className={classes.title}>OTP Verification</h2>
                            <p className={classes.text}>
                                We have sent {resend && "another"} one time pin to
                                <span className={classes.bold}> +94 {msisdn} </span>
                                via SMS.
                            </p>
                        </div>

                        <div className={classes.otp_input_container}>
                            <OTPInput
                                value={otp}
                                shouldAutoFocus
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span className={classes.gap}></span>}
                                renderInput={(props) => (
                                    <input {...props} type="number" className={classes.input_box} />
                                )}
                            />
                        </div>

                        <div className={classes.time_container}>
                            <p className={classes.time_text}>Time remaining: {timer} seconds</p>
                        </div>

                        {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                            <p>Loading....</p>
                        </div> : (
                            <div className={classes.btn_container}>
                                <button
                                    type="button"
                                    className={classes.confirm_btn}
                                    disabled={loading}
                                    onClick={handleFormSubmission}
                                >
                                    Confirm
                                </button>
                                <button
                                    type="button"
                                    className={classes.resend_btn}
                                    disabled={resendLoading}
                                    onClick={resendOtpHandler}
                                >
                                    Resend OTP
                                </button>
                            </div>
                        )}

                    </div>
                </div>
            </div>
        </section>
    )
}

export default OtpPage